import { API_URL } from '../../../app-config/constants';
import { get } from '../request';

getAll.operation = 'READ';
export function getAll(fromDate) {
    return get(`${API_URL}/calendar/upcoming-admin-events?from=` + fromDate);
}
